import { closePageView } from './closePageView'
import { endAccess } from './endAccess'
import { login } from './login'
import { registerPages } from './registerPage'
import { sendAuthCode } from './sendAuthCode'
import { ssoLogin } from './ssoLogin'
import { verifyAuthCode } from './verifyAuthCode'

export const authService = {
  login,
  sendAuthCode,
  ssoLogin,
  verifyAuthCode,
  endAccess,
  registerPages,
  closePageView,
}
